import connection from '@/api/connection'

export const inputdetailsByLote = async ({ commit }, lote) => {
  commit('setInputdetailIsSelecting', true);
  await connection.get(`/inputdetails/lote/${lote}`)
    .then(res => {
      const data = removeDuplicateInObject(res.data.data, 'productId');
      commit('setSelectedListInputdetail', data);
      commit('setInputdetailIsSelecting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputdetailIsSelecting', false);
    });
}

const removeDuplicateInObject = (array, property) => {
  const uniqueIds = [];

  const unique = array.filter(element => {
    const isDuplicate = uniqueIds.includes(element[property]);

    if (!isDuplicate) {
      uniqueIds.push(element[property]);

      return true;
    }

    return false;
  });

  return unique;
}

export const inputdetailById = async ({ commit }, id) => {
  commit('setInputdetailIsLoading', true);
  await connection.get(`/inputdetails/${id}`)
    .then(res => {
      commit('setInputdetail', res.data.data);
      commit('setInputdetailIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputdetailIsLoading', false);
    });
}

export const storeInputdetail = async ({ commit }, inputdetail) => {
  commit('setInputdetailIsCreating', true);
  await connection.post(`/inputdetails/create`, inputdetail)
    .then(res => {
      commit('saveNewInputdetails', res.data);
      commit('setInputdetailIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputdetailIsCreating', false);
    });
}

export const updateInputdetail = async ({ commit }, inputdetail ) => {
  commit('setInputdetailIsUpdating', true);
  await connection.put(`/inputdetails/${inputdetail.id}/update`, inputdetail)
    .then(res => {
      commit('saveUpdatedInputdetail', res.data);
      commit('setInputdetailIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputdetailIsUpdating', false);
    });
}

export const deleteInputdetail = async ({ commit }, inputdetail) => {
  commit('setInputdetailIsDeleting', true);
  await connection.delete(`/inputdetails/${inputdetail.id}/delete`)
    .then(res => {
      commit('setDeleteInputdetail', res.data);
      commit('setInputdetailIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setInputdetailIsDeleting', false);
    });
}
